"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Status = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../../ui");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var verified = function verified(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M22 11L19.56 8.21L19.9 4.52L16.29 3.7L14.4 0.5L11 1.96L7.6 0.5L5.71 3.69L2.1 4.5L2.44 8.2L0 11L2.44 13.79L2.1 17.49L5.71 18.31L7.6 21.5L11 20.03L14.4 21.49L16.29 18.3L19.9 17.48L19.56 13.79L22 11ZM9.09 15.72L5.29 11.91L6.77 10.43L9.09 12.76L14.94 6.89L16.42 8.37L9.09 15.72Z",
    fill: "#41C6A7"
  }));
};
verified.defaultProps = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StatusStyle = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 42px;\n"])));
var Verified = (0, _styledComponents.default)(_ui.P)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", " {\n    margin-left: 10px;\n  }\n"])), _ui.Svg);
var NotVerified = (0, _styledComponents.default)(_ui.H6)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  color: ", ";\n  margin-bottom: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.danger;
});
var Status = function Status(_ref2) {
  var confirmed = _ref2.confirmed;
  var _useTranslation = (0, _reactI18next.useTranslation)('libSettings'),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement(StatusStyle, null, confirmed ? /*#__PURE__*/_react.default.createElement(Verified, null, t('verified'), /*#__PURE__*/_react.default.createElement(_ui.Svg, {
    as: verified
  })) : /*#__PURE__*/_react.default.createElement(NotVerified, null, t('notVerified'), /*#__PURE__*/_react.default.createElement(_ui.StatusTitle, {
    noText: true,
    dotPosition: "right",
    dotProps: {
      color: 'danger',
      size: 10
    }
  })));
};
exports.Status = Status;